// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';
/* eslint camelcase: 0 */

/* eslint no-unused-vars: 0 */

var _objectWithoutProperties = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function buildXpackMlUpdateFilter(opts) {
  // eslint-disable-next-line no-unused-vars
  var makeRequest = opts.makeRequest,
      ConfigurationError = opts.ConfigurationError,
      handleError = opts.handleError,
      snakeCaseKeys = opts.snakeCaseKeys;
  /**
   * Perform a [xpack.ml.update_filter](undefined) request
   *
   * @param {string} filter_id - The ID of the filter to update
   * @param {object} body - The filter update
   */

  var acceptedQuerystring = [];
  var snakeCase = {};
  return function xpackMlUpdateFilter(params, options, callback) {
    options = options || {};

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (typeof params === 'function' || params == null) {
      callback = params;
      params = {};
      options = {};
    } // check required parameters


    if (params['filter_id'] == null && params['filterId'] == null) {
      var err = new ConfigurationError('Missing required parameter: filter_id or filterId');
      return handleError(err, callback);
    }

    if (params['body'] == null) {
      var _err = new ConfigurationError('Missing required parameter: body');

      return handleError(_err, callback);
    } // validate headers object


    if (options.headers != null && typeof options.headers !== 'object') {
      var _err2 = new ConfigurationError("Headers should be an object, instead got: ".concat(typeof options.headers));

      return handleError(_err2, callback);
    }

    var warnings = [];

    var _params = params,
        method = _params.method,
        body = _params.body,
        filterId = _params.filterId,
        filter_id = _params.filter_id,
        querystring = _objectWithoutProperties(_params, ["method", "body", "filterId", "filter_id"]);

    querystring = snakeCaseKeys(acceptedQuerystring, snakeCase, querystring, warnings);

    if (method == null) {
      method = 'POST';
    }

    var ignore = options.ignore;

    if (typeof ignore === 'number') {
      options.ignore = [ignore];
    }

    var path = '';
    path = '/' + '_xpack' + '/' + 'ml' + '/' + 'filters' + '/' + encodeURIComponent(filter_id || filterId) + '/' + '_update'; // build request object

    var request = {
      method: method,
      path: path,
      body: body || '',
      querystring: querystring
    };
    options.warnings = warnings.length === 0 ? null : warnings;
    return makeRequest(request, options, callback);
  };
}

module.exports = buildXpackMlUpdateFilter;